"use strict";

var baseCallEach = require("../.internal/baseCallEach.js");

var map = require("./map.js");

var object = require("./object.js");

module.exports = baseCallEach(map, object);